<template>
  <div class="customize-container">
    <button
      :class="{
        'customize-button': true,
        disabled: type === -1,
        active: type === 0 && touching
      }"
      @click="handleClick"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      {{ content }}
    </button>
  </div>
</template>

<script>
export default _extend({
  name: 'CustomizeButton',
  props: {
    content: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: -1
    },
    onClick: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      touching: false
    };
  },
  methods: {
    handleClick() {
      if (this.onClick && !this.type) {
        this.onClick();
      }
    },
    handleTouchStart() {
      this.touching = true;
    },
    handleTouchEnd() {
      this.touching = false;
    }
  }
  // computed: {
  //   style() {
  //     let color = '';
  //     if (this.type === -1) {
  //       color = '#C2E3FF';
  //     } else if (this.type === 0 && !this.touching) {
  //       color = '#35A4FF';
  //     } else if (this.type === 0 && this.touching) {
  //       color = '#2E90E0';
  //     }
  //     return {
  //       backgroundColor: color
  //     };
  //   }
  // }
});
</script>

<style lang="scss" scoped>
@import './CustomizeButton.scss';
</style>



// WEBPACK FOOTER //
// src/components/NewComponents/CustomizeButton/CustomizeButton.vue